import React, { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { BURN_BSA_TYPES } from '../utils/shared/lundBrowderUtils';
import BodySiteCanvasColorButton from './BodySiteCanvasColorButton';
import { bodySiteCanvasDims } from './bodySiteCanvasUtils';

const BodySiteCanvasColorButtonContainer = ({
	selectColor,
	frontData,
	backData,
	brushColor,
	dims,
	isLandscape,
}) => {

	const tbsaData = useMemo(() => {
		const tbsa = { ...frontData.tbsa };
		Object.keys(backData.tbsa).map((key) => {
			tbsa[key] = tbsa[key] ? tbsa[key] + backData.tbsa[key] : backData.tbsa[key];
		});
		return tbsa;
	}, [frontData, backData]);

	const styles = StyleSheet.create({
		container: {
			position: 'absolute',
			zIndex: 20,
			bottom: 10,
			height: dims.height / bodySiteCanvasDims.buttonContainerScale,
			justifyContent: 'space-between',
		},
	});

	return (
		<>
			<View style={[
				styles.container,
				{
					left: 0,
					alignItems: 'flex-start',
				}
			]}>
				{Object.keys(BURN_BSA_TYPES).slice(0,5).map((itemKey) => {
					const item = BURN_BSA_TYPES[itemKey];
					return (
						<BodySiteCanvasColorButton
							key={item.code}
							code={item.code}
							color={item.color}
							isSelected={item.color === brushColor}
							textColor={item.textColor}
							displayText={item.display}
							tbsaData={tbsaData}
							onPress={() => selectColor(item.color)}
							isLeft={true}
							dims={dims}
							isLandscape={isLandscape}
						/>
					);
				}
				)}
			</View>
			<View style={[
				styles.container,
				{
					right: 0,
					alignItems: 'flex-end',
				}
			]}>
				{Object.keys(BURN_BSA_TYPES).slice(5,10).map((itemKey) => {
					const item = BURN_BSA_TYPES[itemKey];
					return (
						<BodySiteCanvasColorButton
							key={item.code}
							code={item.code}
							color={item.color}
							isSelected={item.color === brushColor}
							textColor={item.textColor}
							displayText={item.display}
							tbsaData={tbsaData}
							onPress={() => selectColor(item.color)}
							isLeft={false}
							dims={dims}
							isLandscape={isLandscape}
						/>
					);
				}
				)}
			</View>
		</>
	);
};

export default memo(BodySiteCanvasColorButtonContainer);